import { render, staticRenderFns } from "./PageMenusListe.vue?vue&type=template&id=645b7392&scoped=true&"
import script from "./PageMenusListe.vue?vue&type=script&lang=js&"
export * from "./PageMenusListe.vue?vue&type=script&lang=js&"
import style0 from "./PageMenusListe.vue?vue&type=style&index=0&id=645b7392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645b7392",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('645b7392')) {
      api.createRecord('645b7392', component.options)
    } else {
      api.reload('645b7392', component.options)
    }
    module.hot.accept("./PageMenusListe.vue?vue&type=template&id=645b7392&scoped=true&", function () {
      api.rerender('645b7392', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Menus/PageMenusListe.vue"
export default component.exports